import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ItemTileGrid from '../../itemTile/ItemTileGrid'
import {
  loadPlanEntries,
  clearAllFilters,
  clearPlanEntries,
  loadPlanEntriesSuccess
} from '../../../redux/actions/planEntries'
import ClassFinderTopSection from './ClassFinderTopSection'
import AloIcon from '../../../../assets/codicons/a'
import { getPlanEntryGridState } from '../../../redux/selectors/planEntries'
import { currentUser } from '../../../redux/selectors/user'
import ClassFinderNewFilteredList from './ClassFinderNewFilteredList'
import { Box } from 'ui/bend'
import { ClassCard } from 'components_v1/SchemaSectionRenderer/common/components'
import usePlaylistDrawer from 'hooks/usePlaylistDrawer'
import CommonLink from 'components_v2/CommonLink'

const NUM_ENTRIES_INIT_VISIBLE_NON_AUTOPAGINATE = 6

const ClassFinderContent = (props) => {
  const [cards, setCards] = useState([])

  const updatePlaylistList = (updatedPlaylistIds) => {
    const updatedCards = cards.map((card) =>
      card.id === selectedCardData?.id
        ? { ...card, playlistIds: updatedPlaylistIds }
        : card
    )
    props.loadPlanEntriesSuccess(updatedCards, props.totalPlanEntries)
  }

  const { handlePlaylistIconClick, AddToPlaylistDrawer, selectedCardData } =
    usePlaylistDrawer(updatePlaylistList)

  useEffect(() => {
    setCards(props.planEntries)
  }, [props.planEntries])

  let planEntryTiles
  if (props.planEntries) {
    planEntryTiles = props.planEntries.map((entry) => (
      <div className='single-class-cell product' key={entry.id}>
        <Box mx={'calc(24*(100vw/1440))'}>
          <ClassCard
            {...entry}
            isFevIcon={Boolean(props?.currentUser)}
            membershipTier={props?.currentUser?.membershipTier}
            isGridView={props.layout === 'tile'}
            onPlaylistIconClick={() => handlePlaylistIconClick(entry)}
          />
        </Box>
      </div>
    ))
  }

  return (
    <>
      {window.innerWidth > 1024 ? (
        <ClassFinderNewFilteredList
          includeFilters={props.includeFilters}
          dropdownOptions={props.dropdownOptions}
          preloadedFilters={props.preloadedFilters}
          baseUrl={props.baseUrl}
          withSubcategories={props.withSubcategories}
        />
      ) : null}
      <div className='class-finder'>
        <ClassFinderTopSection
          includeFilters={props.includeFilters}
          dropdownOptions={props.dropdownOptions}
          preloadedFilters={props.preloadedFilters}
          baseUrl={props.baseUrl}
          withSubcategories={props.withSubcategories}
          userPresent={Boolean(props?.currentUser)}
        />
        <div className='class-cards-grid'>
          <ItemTileGrid
            autopaginate={props.autopaginate}
            seeMoreBtnLabel={
              props.dropdownOptions?.instructors?.length > 1
                ? ''
                : `See More Of ${props.dropdownOptions?.instructors?.[0]?.user?.firstName}'s Classes`
            }
            numInitialShow={NUM_ENTRIES_INIT_VISIBLE_NON_AUTOPAGINATE}
            itemsLength={props.planEntries ? props.planEntries.length : 0}
            totalItems={props.totalPlanEntries}
            renderItemTiles={() => {
              if (!props.isInitialLoad) {
                if (!props.isLoading && props.planEntries?.length === 0) {
                  return (
                    <div
                      className='no-results empty-state'
                      style={{ margin: '0 auto' }}
                    >
                      <AloIcon />
                      <div>
                        <h3 className='empty-header'>
                          We looked but this search has zero matches
                        </h3>
                        <CommonLink
                          to='/class-finder?order=date&from=nav'
                          className='see-more'
                        >
                          Try using different filter options
                        </CommonLink>
                      </div>
                    </div>
                  )
                } else {
                  return (
                    <React.Fragment>
                      {planEntryTiles}
                      {AddToPlaylistDrawer}
                    </React.Fragment>
                  )
                }
              }
            }}
            additionalClassNames={['single-class-grid', 'plan-entry-grid']}
            layout={props.layout}
            isLoading={props.isLoading}
            hasMore={
              props.planEntries &&
              props.planEntries?.length < props.totalPlanEntries
            }
            onLoadMore={props.loadPlanEntries}
          />
        </div>
      </div>
    </>
  )
}

ClassFinderContent.propTypes = {
  autopaginate: PropTypes.bool,
  baseUrl: PropTypes.string,
  clearAllFilters: PropTypes.func,
  currentUser: PropTypes.object,
  includeFilters: PropTypes.bool,
  isInitialLoad: PropTypes.bool,
  isLoading: PropTypes.bool,
  layout: PropTypes.string,
  loadPlanEntries: PropTypes.func,
  page: PropTypes.number,
  preloadedFilters: PropTypes.object,
  planEntries: PropTypes.array,
  totalPlanEntries: PropTypes.number,
  withSubcategories: PropTypes.bool,
  dropdownOptions: PropTypes.object,
  clearPlanEntries: PropTypes.func
}

const mapStateToProps = (state) => {
  const planEntriesGridState = getPlanEntryGridState(state)

  return {
    layout: planEntriesGridState.layout,
    isInitialLoad: planEntriesGridState.isInitialLoad,
    isLoading: planEntriesGridState.isLoading,
    totalPlanEntries: parseInt(planEntriesGridState.total),
    currentUser: currentUser(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlanEntries: (reloadAll = false) => {
      dispatch(loadPlanEntries(reloadAll))
    },
    clearAllFilters: () => {
      dispatch(clearAllFilters())
    },
    clearPlanEntries: () => {
      dispatch(clearPlanEntries())
    },
    loadPlanEntriesSuccess: (planEntries, totalPlanEntries) => {
      dispatch(loadPlanEntriesSuccess(planEntries, totalPlanEntries))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassFinderContent)
